import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center mt-6"
}
const _hoisted_2 = { class: "asset__progress-value" }

import { computed, unref, onMounted, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { differenceInMilliseconds, startOfDay, endOfDay } from 'date-fns';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'AppAssetProgress',
  setup(__props) {

const { state } = useStore();

// #data
const now = ref<number>(Date.now());
const intervalId = ref<ReturnType<typeof setInterval> | null>(null);

// #computed
const diff = computed<number>(() => {
  const { timeDiff } = state.sync ?? {};
  return timeDiff || 0;
});

const isPaused = computed<boolean>(() => {
  const { auction = {} } = unref(state.asset) ?? {};
  return !!(auction as any)?.isPaused;
});

const progress = computed<number>(() => {
  const {
    auction = {
      endDate: '',
      startDate: ''
    }
  } = unref(state.asset) ?? {};
  const { endDate = '', startDate = '' } = auction ?? {};
  const timeDiff = diff.value * 1000; // in milliseconds;
  let start = startDate ? new Date(startDate) : startOfDay(now.value);
  let end = endDate ? new Date(endDate) : endOfDay(now.value);

  const totalMillisInRange = differenceInMilliseconds(end, start);
  const elapsedMillis = differenceInMilliseconds(now.value, start) + timeDiff;
  const result = Math.max(
    0,
    Math.min(100, (100 * elapsedMillis) / totalMillisInRange)
  );
  return Math.round(result);
});

// #hooks
onMounted(() => {
  intervalId.value = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onBeforeUnmount(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (!isPaused.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_progress_linear, {
          class: "asset__progress",
          "model-value": progress.value,
          "bg-color": "pink-lighten-3",
          color: "#18A1C8"
        }, null, 8, ["model-value"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(progress.value || 0) + "%", 1)
      ]))
    : _createCommentVNode("", true)
}
}

})